import DataGridTableSkeleton from "../../../../components/skeletons/DataGridTableSkeleton";

export default function ManufacturerListSkeleton() {
  return (
    <DataGridTableSkeleton height={500} rowCount={10} />
  );
}
